import React from 'react';
import classNames from 'classnames';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

const getStyles = () => ({
  shimmerWrapper: {
    height: '100%',
    padding: '30px 0',
    background: '#fff',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    borderRadius: '2px',
    '& .header-shimmer': {
      margin: '20px 0',
    },
    '& .select-shimmer, .label-shimmer': {
      marginTop: 5,
    },
  },
});

export const LanguageCountryStepShimmer = () => {
  const classes = useDefaultStyles(getStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const isSmallSize = displayMode === 's';

  return (
    <div className={classNames('shimmer-wrapper', classes.shimmerWrapper)}>
      <div className="icon-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '44px', width: '50px' }} /> </Skeleton>
      </div>
      <div className="header-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '22px', width: isSmallSize ? '200px' : '244px' }} /> </Skeleton>
      </div>
      <div className="label-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '21px', width: isSmallSize ? '220px' : '280px' }} /> </Skeleton>
      </div>
      <div className="select-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px', width: isSmallSize ? '240px' : '360px' }} /> </Skeleton>
      </div>
      <div className="label-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '21px', width: isSmallSize ? '220px' : '280px' }} /> </Skeleton>
      </div>
      <div className="select-shimmer">
        <Skeleton appearance="translucent" > <SkeletonItem style={{ height: '32px', width: isSmallSize ? '240px' : '360px' }} /> </Skeleton>
      </div>
    </div>
  );
};
